import vocho from '../../assets/vocho.png';
import '../../styles/underConstruction.css';
function UnderConstruction() {
    return(  
       <div className="div-underConstruction">
          <div className = 'div-vocho'>
               <img className = 'vocho' src={vocho} alt="vocho_GARAGEGDL" />
          </div>
       </div>
   )
   }
   export default UnderConstruction;